// extracted by mini-css-extract-plugin
export default {"recaptcha-compact":"BasicData_recaptcha-compact__WdOcG","recaptcha-normal":"BasicData_recaptcha-normal__dxMR0"};